import React from 'react';
import ReactDOM from 'react-dom';
import styles from './modals.module.css';

export const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm
}) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className={styles.deleteConfirmationOverlay} onClick={onClose}>
      <div className={styles.deleteConfirmationModal} onClick={(e) => e.stopPropagation()}>
        <button type="button" className={styles.deleteConfirmationClose} onClick={onClose}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 1.4L14.6 0L8 6.6L1.4 0L0 1.4L6.6 8L0 14.6L1.4 16L8 9.4L14.6 16L16 14.6L9.4 8L16 1.4Z" fill="#505050"/>
          </svg>
        </button>
        <p className={styles.deleteConfirmationText}>Are you Sure you want to Delete these images?</p>
        <div className={styles.deleteConfirmationActions}>
          <button type="button" className={styles.deleteConfirmationYes} onClick={onConfirm}>Yes, Delete</button>
          <button type="button" className={styles.deleteConfirmationNo} onClick={onClose}>No, let me change selection</button>
        </div>
      </div>
    </div>,
    document.body
  );
};
